window.$ = window.jQuery = require('jquery');
require('./common/recaptchav3');
require('./common/currentLocale');
require('./components/dropdown-select-lang');
import './accessibility/blocks-a11y';
import './accessibility/cookie-banner-a11y';
